import './team-member.css'
import './static/instagram.svg'
import './static/linkedin.svg'
import './static/twitter.svg'
